import script from "./SoftwareMonitoring.vue?vue&type=script&lang=ts&setup=true"
export * from "./SoftwareMonitoring.vue?vue&type=script&lang=ts&setup=true"

import "./SoftwareMonitoring.vue?vue&type=style&index=0&id=2479593c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2479593c"]])

export default __exports__